module.exports = __webpack_public_path__ + "img/0131.a01f17cb.png";